export default __webpack_public_path__ + "static/media/nianalogout.38558e70.png";